const t = {
  name: "DocumentAction",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,40h24c3.9,0,7-3.1,7-7c0-3.5-2.6-6.4-6-6.9V11.6L16.4,0H3C1.3,0,0,1.3,0,3v34C0,38.7,1.3,40,3,40z M3,2h11
			v8.8c0,1.8,1.4,3.2,3.2,3.2H26v12.1c-3.4,0.5-6,3.4-6,6.9c0,2,0.8,3.7,2.1,5H3c-0.5,0-1-0.5-1-1V3C2,2.5,2.5,2,3,2z M16,2.4
			l9.6,9.6h-8.4c-0.6,0-1.2-0.5-1.2-1.2V2.4z M27,28c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5s-5-2.2-5-5C22,30.2,24.2,28,27,28z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as DocumentAction
};
